import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ShowToast } from "../../../../components/toast";
import { api } from "../../../../helpers/api";
import FullScreenModal from "../../../../components/FullScreenModal";
import { TABS } from "./Tabs";
import { Reviews } from "./Reviews";
import { ReactComponent as DownArrowIcon } from "../../../../assets/icons/arrow-left.svg";
import { Rating } from "./Rating";

export function ReviewModal({ isOpen, onClose, type, user, refresh }) {
  return (
    <>
      <FullScreenModal isOpen={isOpen} onClose={onClose}>
        <div className="max-w-[898px] mx-auto mt-[34px]">
          <div className="mx-10 justify-between items-center flex">
            <div className="justify-start items-center gap-[15px] flex">
              <button
                onClick={onClose}
                className="hover:opacity-70 w-10 h-10 bg-[#def5e3] rounded-lg justify-center items-center flex"
              >
                <DownArrowIcon className="w-4 h-4" />
              </button>
              <div className="text-black text-[28px] font-semibold font-['Poppins'] leading-[33.60px]">
                Reviews
              </div>
            </div>
            <div className="justify-start items-center gap-2 flex">
              <div className="justify-start items-center gap-2.5 flex">
                <Rating rating={user?.rating} className="!w-[26px] !h-[26px]" />

                <div className="text-black text-base font-semibold font-['Poppins'] uppercase leading-normal">
                  {user?.rating}
                </div>
              </div>
              <div className="opacity-50 text-black text-base font-normal font-['Poppins'] leading-normal">
                ({user?.totalReviews} reviews)
              </div>
            </div>
          </div>
          <Reviews user={user} refresh={refresh} isSalon={true} />
        </div>
      </FullScreenModal>
    </>
  );
}
